export enum AddingblocksBlockType {
  Same = 'S',
  Opposite = 'O'
}
